import React, { useState } from "react";
import {  FaEnvelope, FaPhone } from "react-icons/fa";

const PageContact = ({ className = "" }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const response = await fetch("/api/customer/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error("Failed to send message");
      // Handle success
    } catch (error) {
      setErrorMessage("Failed to send message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`min-h-screen bg-gray-50 px-4 py-8 ${className}`}>
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Contact us</h1>
          <p className="text-lg text-gray-600">
            You can always email us at{" "}
            <a href="mailto:pr@feelaxo.com" className="text-red-600 hover:text-red-700">
              pr@feelaxo.com
            </a>
          </p>
        </div>

        {/* Contact Options */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {/* Chat Option */}
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <FaEnvelope className="w-12 h-12 mx-auto mb-4 text-red-600" />
            <h2 className="text-xl font-semibold mb-3">Chat with Us</h2>
            <p className="text-gray-600 mb-6">
              We're here for you. No automatic answers or robots, promise! Start a chat to learn more
              about what we can do for you.
            </p>
            <button 
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg transition-colors"
              onClick={() => window.location.href = "https://api.whatsapp.com/send/?phone=919137573481&text=Hi%2C+I+need+help+using+Feelaxo.+Could+you+guide+me+on+the+next+steps%3F+Thanks%21&type=phone_number&app_absent=0"}
            >
              Start a chat
            </button>
          </div>

          {/* Call Option */}
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <FaPhone className="w-12 h-12 mx-auto mb-4 text-red-600" />
            <h2 className="text-xl font-semibold mb-3">Get on a Call</h2>
            <p className="text-gray-600 mb-6">
              If you'd like to talk on the phone, you can schedule a demo call or give us your number
              and we'll call you back shortly.
            </p>
            <button 
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg transition-colors"
              onClick={() => window.location.href="tel:919137573481"}
            >
              Book a live demo
            </button>
          </div>
        </div>

        {/* Contact Form */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h2 className="text-2xl font-semibold mb-6 text-center">Send us a message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Full name
                </label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="John Doe"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email address
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
              {errorMessage && (
                <p className="text-red-600 text-center">{errorMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContact;